import { render } from "./reg.vue?vue&type=template&id=55dc3762&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"

import "./reg.vue?vue&type=style&index=0&id=55dc3762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dc3762"]])

export default __exports__